import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '@/components/Top'
import InputInfomation from '@/components/InputInfomation'
import Complete from '@/components/Complete'
import SystemError from '@/components/SystemError'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    { path: '/', redirect: '/top' },
    {
      path: '/top',
      name: 'Top',
      component: Top
    },
    {
      path: '/info',
      name: 'InputInfomation',
      component: InputInfomation, beforeEnter: (to, from, next) => {
        if (from.path === '/top' )
          next();
      }
    },
    {
      path: '/complete',
      name: 'Complete',
      component: Complete, beforeEnter: (to, from, next) => {
        if (from.path === '/info')
          next();
      }
    },
    {
      path: '/syserr',
      name: 'SystemError',
      component: SystemError
    }
    ,
    {
      // 定義されていないパスへの対応。トップページへリダイレクトする。
      path: '*',
      redirect: '/top'
    }
  ],
  scrollBehavior (to, from, savedPosition) { // eslint-disable-line no-unused-vars
    return { x: 0, y: 0 ,
      behavior: 'smooth',}
  }
})
